const Language = Object.freeze({
  ENGLISH: 'English',
  CHINESE: 'Chinese',
  FRENCH: 'French',
  GERMAN: 'German',
  ITALIAN: 'Italian',
  JAPANESE: 'Japanese',
  PORTUGUESE: 'Portuguese',
  SIMPLIFIED_CHINESE: 'SimplifiedChinese',
  SPANISH: 'Spanish',
  TRADITIONAL_CHINESE: 'TraditionalChinese',
  AFRIKAANS: 'Afrikaans',
  ARABIC: 'Arabic',
  ARMENIAN: 'Armenian',
  BENGALI: 'Bengali',
  BOKMAL: 'Bokmal',
  BULGARIAN: 'Bulgarian',
  BURMESE: 'Burmese',
  CANTONESE: 'Cantonese',
  CATALAN: 'Catalan',
  CROATIAN: 'Croatian',
  CZECH: 'Czech',
  DANISH: 'Danish',
  DUTCH: 'Dutch',
  ESTONIAN: 'Estonian',
  FINNISH: 'Finnish',
  GEORGIAN: 'Georgian',
  GREEK: 'Greek',
  HEBREW: 'Hebrew',
  HINDI: 'Hindi',
  HUNGARIAN: 'Hungarian',
  ICELANDIC: 'Icelandic',
  INDONESIAN: 'Indonesian',
  KHMER: 'Khmer',
  KOREAN: 'Korean',
  LAO: 'Lao',
  LATVIAN: 'Latvian',
  LITHUANIAN: 'Lithuanian',
  MACEDONIAN: 'Macedonian',
  MONGOLIAN: 'Mongolian',
  NYNORSK: 'Nynorsk',
  PUNJABI: 'Punjabi',
  POLISH: 'Polish',
  ROMANIAN: 'Romanian',
  ROMANIZED_HINDI_URDU: 'RomanizedHindiUrdu',
  RUSSIAN: 'Russian',
  SLOVAK: 'Slovak',
  SWEDISH: 'Swedish',
  TAGALOG: 'Tagalog',
  TAMIL: 'Tamil',
  TELUGU: 'Telugu',
  THAI: 'Thai',
  TURKISH: 'Turkish',
  UKRAINIAN: 'Ukrainian',
  URDU: 'Urdu',
  VIETNAMESE: 'Vietnamese',
  SERBIAN: 'Serbian',
  SERBIAN_NEW: 'SerbianNew',
  ALL: 'All',
  UNKNOWN: 'Unknown'
})
export default Language
export type LanguageStrings = typeof Language[keyof typeof Language]
// RESERVE BELOW
